import { Box, Container } from "@mui/material";
import Image from "next/image";
import { getBlogDateFormatted } from "../../helpers/getDateFormatted";
import cssVars from '../../styles/vars.module.scss'
import Share from "../pp/product-details/actions/share";

const Blog = ({ blog }) => {
    return (
        <Container maxWidth="xl" sx={{ px: { xs: 0, sm: 5, md: 20, lg: 30 } }}>
            {
                blog.image
                    ?
                    <Box position="relative" height={450} border={`1px solid ${cssVars.extraLightGray}`}>
                        <Image fill src={blog.image} alt={`${blog.url_key}-image`} style={{ objectFit: "cover", objectPosition: "center" }} />
                    </Box>
                    :
                    null
            }
            <Box display="flex" alignItems="center" justifyContent="space-between" bgcolor={cssVars.extraLightGray} py={2} px={4} mb={5}>
                <Box fontWeight={500}>{getBlogDateFormatted(blog.publish_date)}</Box>
                <Box sx={{ "& a": { bgcolor: `${cssVars.white} !important`, borderRadius: "50%" } }}>
                    <Share product={blog} />
                </Box>
            </Box>
            <Box fontWeight={600} fontSize={{ xs: "26px", sm: "30px", lg: "40px" }} sx={{ px: { xs: 2, sm: 0 } }}>{blog.name}</Box>
            <Box fontSize={{ xs: "14px", sm: "16px" }} dangerouslySetInnerHTML={{ __html: blog.post_content }} />
        </Container>
    );
}

export default Blog;